<template>
	<div>
		<p>
      Born 1976 <br><br>
      Pål Vatneberg has over 10 years of sales management experience from large international tech and IT companies like Panasonic and Netgear. <br><br>

      In the current position as CSO at Loyal Solutions A/S, Pål Vatneberg is responsible for the company's revenue budget and driving the sales efforts globally, both directly and through partners.<br><br>

      Pål Vatneberg has been employed since 2021 and has been a member of the executive management since 2022.<br><br>

			<strong>Education</strong><br>
      Major degree in Media and Communication, University of Bergen, Norway.<br><br>

			<strong>Other current positions</strong><br>
			None. <br><br>

			<strong>Shareholding in the Company</strong><br>
			Pål Vatneberg owns 225 shares in Loyal Solutions A/S.<br><br>
      Pål Vatneberg will earn the rights up to 11.250 warrants over a period of 12 months. The warrants can be exercised in a period from October 1 2022 up until September 30 2023.
		</p>
	</div>
</template>

<script>
export default {
	name: 'PaalVDescription',
}
</script>
